import { render } from "./DetailRetour.vue?vue&type=template&id=dc152360&ts=true"
import script from "./DetailRetour.vue?vue&type=script&lang=ts"
export * from "./DetailRetour.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__